import { Component, computed, input } from '@angular/core';
import { ForInsert } from 'src/app/types/database';
import { environment } from 'src/environments/environment';
import { IonImg, IonIcon } from "@ionic/angular/standalone";
import { EntityEditFormValue } from 'src/app/models/entity/edit/form';
import { EntityApprovalStatus } from 'src/app/models/entity-approval';

@Component({
  selector: 'app-entity-card',
  templateUrl: './entity-card.component.html',
  styleUrls: ['./entity-card.component.scss'],
  standalone: true,
  imports: [IonIcon, IonImg,]
})
export class EntityCardComponent {

  entity = input.required<EntityEditFormValue>();
  environment = environment;
  avatarUrl = computed(() => {
    const objectId = this.entity().general?.avatar?.[0]?.objectName;
    if (!objectId) return;
    const base = this.environment.supabaseUrl;
    const fullUrl = `${base}/storage/v1/object/public/avatar/${objectId}`;
    return fullUrl;
  });

  EntityApprovalStatus = EntityApprovalStatus;
  status = computed(() => this.entity().status ?? EntityApprovalStatus.Pending);

  getStatusText = computed(() => {
    const status = this.status();
    if (status === EntityApprovalStatus.Approved) return "Approved";
    if (status === EntityApprovalStatus.Rejected) return "Rejected";
    return "Pending";
  });
}
